export const getGlobalPricingHiddenFacets = (globalPricingId: string) => {
  if (!globalPricingId) {
    return {};
  }

  return {
    hiddenFacets: [
      `gp_lowest_price_cents_${globalPricingId}`,
      `gp_instant_ship_lowest_price_cents_${globalPricingId}`,
    ],
    hiddenFields: [
      `gp_lowest_price_cents_${globalPricingId}`,
      `gp_instant_ship_lowest_price_cents_${globalPricingId}`,
    ],
  };
};
